import {
    RETRIEVE_UPLOADED_COMMENTS_BEGIN,
    RETRIEVE_UPLOADED_COMMENTS_SUCCESS,
    RETRIEVE_UPLOADED_COMMENTS_FAILURE,
    FILTER_RETRIEVE_UPLOADED_COMMENTS_BEGIN,
    FILTER_RETRIEVE_UPLOADED_COMMENTS_SUCCESS,
    FILTER_RETRIEVE_UPLOADED_COMMENTS_FAILURE,
    ALL
  } from './constants';
  import http from '../../../common/http';
  import {toast} from "react-toastify";
  import { apiEndPoints } from '../../../common/globalConstants';
  
  function generateRetrieveUploadedCommentsUrl(props) {
    return `${apiEndPoints.uploadedComments.RETRIEVE_UPLOADED_COMMENTS}?fromDate=${props.fromDate}&toDate=${
      props.toDate
    }&topicId=${props.topicId}&pageLimit=${props.pageLimit}&pageId=${props.currentPage}&sentiment=${
      props.sentiments && props.sentiments.length ? props.sentiments.join(',').toLowerCase() : ALL
    }&sortType=${
      props.sortType
    }&minSarcasmScore=${
      props.minSarcasmScore
    }&maxSarcasmScore=${
      props.maxSarcasmScore
    }&relevance=${
      props.relevanceFilterOption
    }`;
  }
  
  export function retrieveAllUploadedComments(props = {}) {
    return dispatch => {
      dispatch({
        type: RETRIEVE_UPLOADED_COMMENTS_BEGIN,
      });
      const url = generateRetrieveUploadedCommentsUrl(props);
      const promise = new Promise((resolve, reject) => {
        const doRequest = http.get(url);
        doRequest.then(
          res => {
            dispatch({
              type: RETRIEVE_UPLOADED_COMMENTS_SUCCESS,
              data:
                res.data.status === 200
                  ? { count: res.data.count, data: res.data.data }
                  : { count: null, data: [] },
            });
            resolve(res);
          },
          err => {
            dispatch({
              type: RETRIEVE_UPLOADED_COMMENTS_FAILURE,
            });
            reject(err);
          },
        );
      });
      return promise;
    };
  }

  export function filterAllUploadedComments(props = {}) {
    return dispatch => {
      dispatch({
        type: FILTER_RETRIEVE_UPLOADED_COMMENTS_BEGIN,
      });
      const url = generateRetrieveUploadedCommentsUrl(props);
      const promise = new Promise((resolve, reject) => {
        const doRequest = http.get(url);
        doRequest.then(
          res => {
            toast.success("Page updated");
            dispatch({
              type: FILTER_RETRIEVE_UPLOADED_COMMENTS_SUCCESS,
              data:
                res.data.status === 200
                  ? { count: res.data.count, data: res.data.data }
                  : { count: null, data: [] },
            });
            resolve(res);
          },
          err => {
            dispatch({
              type: FILTER_RETRIEVE_UPLOADED_COMMENTS_FAILURE,
            });
            reject(err);
          },
        );
      });
      return promise;
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case RETRIEVE_UPLOADED_COMMENTS_BEGIN:
        return {
          ...state,
          retrieveUploadedCommentsBegin: true,
          retrieveUploadedCommentsSuccess: false,
          retrieveUploadedCommentsFailure: false,
        };
      case RETRIEVE_UPLOADED_COMMENTS_SUCCESS: {
        let updatedUploadedCommentsData = [];
        if (state.allUploadedComments.data && action.data.data && 
          (JSON.stringify(state.allUploadedComments.data) !== JSON.stringify(action.data.data)) &&
          (!uploadedCommentsStateAlreadyContainsThisReceivedData(state, action))
          ) {
          updatedUploadedCommentsData = [...state.allUploadedComments.data, ...action.data.data];
        } else if (action.data.data) {
          updatedUploadedCommentsData = action.data.data;
        }
        return {
          ...state,
          retrieveUploadedCommentsBegin: false,
          retrieveUploadedCommentsSuccess: true,
          allUploadedComments: { data: updatedUploadedCommentsData, count: action.data.count },
        };
      }
      case FILTER_RETRIEVE_UPLOADED_COMMENTS_BEGIN:
        return {
          ...state,
          retrieveUploadedCommentsBegin: true,
          retrieveUploadedCommentsSuccess: false,
          allUploadedComments: {},
        };
      case FILTER_RETRIEVE_UPLOADED_COMMENTS_SUCCESS:
        return {
          ...state,
          retrieveUploadedCommentsBegin: false,
          retrieveUploadedCommentsSuccess: true,
          allUploadedComments: { data: action.data.data, count: action.data.count },
        };
      case RETRIEVE_UPLOADED_COMMENTS_FAILURE:
      case FILTER_RETRIEVE_UPLOADED_COMMENTS_FAILURE:
        return {
          ...state,
          retrieveUploadedCommentsBegin: false,
          retrieveUploadedCommentsFailure: true,
        };
      default:
        return state;
    }
  }

  function uploadedCommentsStateAlreadyContainsThisReceivedData(state, action) {
    return (JSON.stringify(state.allUploadedComments.data).includes(JSON.stringify(action.data.data).slice(0,-1)));
  }
  


// WEBPACK FOOTER //
// ./src/features/home/redux/retrieveUploadedComments.js